import { _defineProperty } from "@slyte/core/src/lyte-utils";
import {Route} from "../../../node_modules/@slyte/router/index.js";
let IconsComp;

class Icons extends Route {
    render() {
        return { outlet: '#zcatcomponent', component: IconsComp };
    }

    static actions(arg1) {
        return Object.assign(super.actions({

        }), arg1);
    }

    _() {
        _;
    }

    getRequirements() {
        arguments[1].push(
            import(/* webpackChunkName: "components/javascript/lyte-components/icons-comp" */
            "../../../components/javascript/lyte-components/icons-comp").then(function(res) {
                IconsComp = res.IconsComp;
            })
        );

        
;
    }
}

export {Icons};

